// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15Y_V","colBig":"styles_colBig__jTy-T","colSmall":"styles_colSmall__30nP7","shopifyNameWrapper":"styles_shopifyNameWrapper__3wxvY"};